const POST_MESSAGES = {
  ReloadApprovalApplicationList: 'ReloadApprovalApplicationList',
  ReloadConfirmationRequestList: 'ReloadConfirmationRequestList',
};

export default POST_MESSAGES;
